import React, { useState } from 'react';
import { eventCollectorObjectInterest, trackEventSignupInterestOpen } from 'common/lib/helpers/trackingService';
import PropTypes from 'prop-types';
import { AD_EXPIRED } from 'common/lib/helpers/constants';
import * as _ from 'lodash';
import InterestModal from './InterestModal';

const InterestListButton = ({ adStatus, communicationEmail }) => {
    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        trackEventSignupInterestOpen();
        eventCollectorObjectInterest('start');
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleKeyUp = event => {
        if (event.keyCode === 13) {
            openModal();
        }
    };

    return (
        <>
            <button
                type="button"
                className={`button button--primary min-w-full ${
                    adStatus === AD_EXPIRED || _.isEmpty(communicationEmail) ? ' button--is-disabled' : ''
                } `}
                tabIndex="0"
                onClick={() => openModal()}
                onKeyUp={e => handleKeyUp(e)}
            >
                Meld interesse
            </button>
            <InterestModal showModal={showModal} closeModal={closeModal} />
        </>
    );
};

InterestListButton.propTypes = {
    adStatus: PropTypes.string.isRequired,
    communicationEmail: PropTypes.string,
};
export default InterestListButton;
